class AsyncForm {

    /**
     *
     * @param form
     * @param submitButton
     */
    constructor(form, submitButton) {
        /**
         * @type {HTMLElementTagNameMap}
         */
        this.form = form;
        /**
         * @type {*|Element}
         */
        this._submitButton = submitButton || '.btn-ajax';
        /**
         * @type {string}
         */
        this.name = this.form.name;
        /**
         * @type {FormData}
         */
        this.formData = undefined;
        /**
         * @type {string}
         */
        this.action = this.form.action;
        /**
         * @type {boolean}
         */
        this.json = true;
        /**
         * @type {Loader}
         */
        this.loader = new Loader();
        /**
         * @type {Http}
         */
        this.http = new Http();
        /**
         * @type function
         */
        this.onSuccess = () => {
        };
        /**
         * Init
         */
        this._init();
    }

    /**
     *
     * @param e
     * @private
     */
    static _swapForm(e) {
        const TARGET_FORM = document.querySelector(e.target.getAttribute('data-show'));
        const FORM_SWAP   = document.querySelectorAll('[data-swap]');

        // Hide swap form
        for (let i = 0; i < FORM_SWAP.length; i++) {
            FORM_SWAP[i].classList.remove('active')
        }

        // Display target
        TARGET_FORM.classList.add('active');

        Modal.setModalHeight(TARGET_FORM.closest('.modal'));
    }

    /**
     * Remove global message
     * @private
     */
    static _removeGlobalFormInfo() {
        const ERROR_ELEMENT = document.getElementById('global-error-register');
        ERROR_ELEMENT && ERROR_ELEMENT.parentNode.removeChild(ERROR_ELEMENT);
    }

    /**
     * Event data show element
     * @param element
     * @private
     */
    static _showElement(element) {
        const ID_ELEMENT_TO_SHOW = element.getAttribute('data-next-step-active-id');
        const ELEMENT            = document.getElementById(ID_ELEMENT_TO_SHOW);

        ELEMENT.classList.add('active')
    }

    getSubmitButton() {
        return this._submitButton;
    }

    setSubmitButton(idOrClass) {
        this._submitButton = idOrClass;
    }

    setJson(enable) {
        if (typeof enable !== 'boolean') {
            console.error('The json attribute must be a boolean');
        }
        this.json = enable;
    }

    /**
     * Init
     * @private
     */
    _init() {
        this._addListener();
    }

    /**
     * RefreshForm
     * @return {Promise | Promise}
     */
    refreshForm() {
        return new Promise((resolve) => {
            setTimeout(() => {
                this.form = document.querySelector('[name=' + this.name + ']');
                this._addListener();
                return resolve();
            }, 100);
        })
    }

    /**
     * Add listener
     * @private
     */
    _addListener() {
        const HIT_SHOW   = this.form.querySelectorAll('[data-show]');
        const INPUTS     = this.inputs = this.form.querySelectorAll('input');
        const BTN_SUBMIT = this.form.querySelector(this._submitButton);

        if (!BTN_SUBMIT) return;

        for (let i = 0; i < HIT_SHOW.length; i++) {
            HIT_SHOW[i].addEventListener('click', (e) => AsyncForm._swapForm(e));
        }

        for (let i = 0; i < INPUTS.length; i++) {
            INPUTS[i].addEventListener('keyup', (event) => {
                event.preventDefault();
                if (event.keyCode === 13) {
                    BTN_SUBMIT.click();
                }
            });
        }

        BTN_SUBMIT.addEventListener('click', () => this._ajaxSubmit());
    }

    /**
     * Submit Ajax
     * @private
     */
    _ajaxSubmit() {
        this._formAwait();
        this.formData = new FormData(this.form);
        AsyncForm._removeGlobalFormInfo();

        // Async
        this.http.ajax({url: this.form.action, type: 'POST', formData: this.formData})
            .then((response) => {
                if (this.form.name === 'brokenLink') {
                    response = `<p class="success">Votre message a bien été envoyé</p> ${response}`;
                }

                this._formReady();
                this._boltFormSuccess(response);
                this.onSuccess(response);
            })
            .catch((e) => {
                this._formReady();
                this._boltFormError();
            });
    }

    /**
     * Callback before form submission. Override at will
     * @private
     */
    _boltFormError() {
        this.form.outerHTML = '<div class="alert danger">Erreur, veuillez essayer ultérieurement</div>'
    };

    /**
     * Callback after form submission. Override at will
     * @param response
     * @private
     */
    _boltFormSuccess(response) {
        this.form.querySelector(this._submitButton).removeEventListener('click', () => this._ajaxSubmit());
        this.form.outerHTML = response;
        new google.maps.places.Autocomplete(document.getElementById('suggest-tool_location'), {

            types                 : ["(regions)"],
            components            : {country: "fr"},
            componentRestrictions : {country: "fr"},

        });
        this.refreshForm().then(() => {
            this._checkResponseError(response);
        });
    };

    /**
     * Check if form error
     * @param response
     * @private
     */
    _checkResponseError(response) {
        // If no error
        if (response.indexOf('boltform-error') === -1) {
            this._renderFeedback();
        }
    }

    /**
     * Form Await
     * @private
     */
    _formAwait() {
        this.loader.config.color = '#0081C8';
        this.loader.show();
        this.form.querySelector(this._submitButton).disabled = true;
        this.form.style.opacity                              = '0.3';
    }

    /**
     * Form ready
     * @private
     */
    _formReady() {
        this.loader.hide();
        this.form.querySelector(this._submitButton).disabled = false;
        this.form.style.opacity                              = '1';
    }

    /**
     * Set global message
     * @param message
     * @param type
     * @private
     */
    _setGlobalFormInfo(message, type) {
        const ERROR_ELEMENT = document.getElementById('global-error-register');
        let htmlEl          = document.createElement('div');
        htmlEl.setAttribute('id', 'global-error-register');
        htmlEl.setAttribute('class', 'alert ' + type);
        htmlEl.style.margin = '10px 0';
        htmlEl.innerHTML    = message;

        if (ERROR_ELEMENT) {
            ERROR_ELEMENT.innerHTML = htmlEl;
        } else {
            let hitShow = htmlEl.querySelectorAll('[data-show]');
            for (let i = 0; i < hitShow.length; i++) {
                hitShow[i].addEventListener('click', (e) => AsyncForm._swapForm(e));
            }

            this.form.insertAdjacentElement('afterend', htmlEl);
        }
    }

    _setFieldInfo(message, field) {
        const FORM_FIELD_IN_ERROR = this.form.querySelector(`[name="register[${field}]"]`);
        let htmlUlEl              = document.createElement('ul');
        let htmlLiEl              = document.createElement('li');

        htmlUlEl.classList.add('boltform-error');
        htmlLiEl.classList.add('boltform-error');
        htmlLiEl.innerText = message;
        htmlUlEl.appendChild(htmlLiEl);

        if (FORM_FIELD_IN_ERROR) {
            FORM_FIELD_IN_ERROR.insertAdjacentElement('afterend', htmlUlEl);
            FORM_FIELD_IN_ERROR.focus();
        }
    }

    /**
     * Feedback
     * @private
     */
    _renderFeedback() {
        const URL             = this.form.querySelector('[data-url-after-checked]') && this.form.querySelector('[data-url-after-checked]').getAttribute('data-url-after-checked');
        const SUCCESS_MESSAGE = this.form.querySelector('[data-feedback-success]')
            ? this.form.querySelector('[data-feedback-success]').getAttribute('data-feedback-success')
            : 'Votre message a bien été envoyé';

        if (URL) {
            this._formAwait();
            this.http.ajax({url: URL, type: 'POST', formData: this.formData})
            .then((response) => {
                    if (this.form.name === 'login' || this.form.name === 'profile') {
                        if (window.location.pathname === '/mon-score-rso') {
                            location.href = '/mon-score-rso/tableau-de-bord-rso';
                        } else {
                            location.reload();
                        }
                        return;
                    }

                    if (this.form.name === 'register') {
                        if (window.location.pathname === '/outils') {
                            location.reload();
                        } else {
                            location.href = '/mon-score-rso?from_registration=1';
                        }
                        return;
                    }

                    this._formReady();
                    this.form.style.display = 'none';
                    if (this.json) {
                        const RESPONSE = JSON.parse(response);
                        this._setGlobalFormInfo(RESPONSE.message || SUCCESS_MESSAGE, 'success');
                    } else {
                        this._setGlobalFormInfo(response);
                    }

                })
                .catch((e) => {
                    console.log('e', e);
                    try {
                        const exception        = this.json ? JSON.parse(e) : e;
                        const IS_EMPTY_CONTEXT = Object.entries(exception.context).length === 0 && exception.context.constructor === Object;

                        this._formReady();
                        if (IS_EMPTY_CONTEXT && exception.context['field']) {
                            this._setGlobalFormInfo(exception.message, 'danger');
                        } else {
                            this._setFieldInfo(exception.message, exception.context['field']);
                        }
                    } catch (e) {
                        this._formReady();
                        this._setGlobalFormInfo('Une erreur est survenue', 'danger');
                    }
                });
        } else {
            this.form.style.display = 'none';
            this._setGlobalFormInfo(SUCCESS_MESSAGE, 'success');
        }
    }
}
